import { Component, Input, ViewEncapsulation } from '@angular/core'
import { MapPin } from '@shared/interfaces/pins.interface'
import * as Leaflet from 'leaflet'
import { Config } from '@shared/config';
import OpenStreetMapBaseComponent from '@layouts/default/components/open-street-map-base/open-street-map-base.component'

@Component({
    selector: 'app-landing-page-open-street-map',
    templateUrl: './landing-page-open-street-map.component.html',
    styleUrls: [
        '../open-street-map-base/open-street-map-base.component.scss',
        './landing-page-open-street-map.component.scss'
    ],
    encapsulation: ViewEncapsulation.None
})
export default class LandingPageOpenStreetMapComponent extends OpenStreetMapBaseComponent
{
    private _pins: MapPin[] = []

    @Input() set pins(pins: MapPin[]) {
        this._pins = pins
        this.refreshMarkersList()
    }
    @Input() eventMarkerClass: string = 'event-marker'
    @Input() projectMarkerClass: string = 'project-marker'

    mapOptions(): Leaflet.MapOptions {
        return {
            layers: Config.OPEN_STREET_MAP_LAYERS,
            zoom: 5,
            center: Config.LANDING_PAGE_MAP_CENTRE_POINT as Leaflet.LatLngLiteral,
            gestureHandling: true
        } as Leaflet.MapOptions
    }

    afterClusterLoad() {
        this.refreshMarkersList()
    }

    markerCssClass(pin: MapPin): string {
        if (pin.markerType == 'project') {
            return this.projectMarkerClass
        } else if (pin.markerType == 'ambassador') {
            return 'ambassador-marker'
        } else {
            return this.eventMarkerClass
        }
    }

    refreshMarkersList (): void {
        if (this.markersCluster == null) {
            return
        }

        this.markersCluster.clearLayers()
        const that = this

        const markers= this._pins.map((pin: MapPin) => {
            // @ts-ignore
            const marker = Leaflet.marker([pin.latitude, pin.longitude], {
                icon: Leaflet.divIcon({
                    className: 'osm-map-marker ' + that.markerCssClass(pin),
                    iconSize: [that.MARKER_ICON_WIDTH, that.MARKER_ICON_HEIGHT],
                    iconAnchor: [that.MARKER_ICON_WIDTH / 2, that.MARKER_ICON_HEIGHT]
                })
            })

            that.addMarkerEvents(marker, pin)

            return marker
        })

        this.markersCluster.addLayers(markers)
    }
}
